import {
  SELECT_MODAL_LIST,
  SELECT_MODAL_LIST_SUCCESS,
  SELECT_MODAL_LIST_ERROR,
  SELECT_MODAL_SELECTED,
  SELECT_MODAL_SELECTED_SUCCESS,
  SELECT_MODAL_SELECTED_ERROR,
  SELECT_MODAL_UPDATE,
  SELECT_MODAL_UPDATE_SUCCESS,
  SELECT_MODAL_UPDATE_ERROR,
} from "./actionTypes"

const initialState = {
  responseList: "",
  loadingList: false,
  errorList: "",
  responseSelected: "",
  loadingSelected: false,
  errorSelected: "",
  responseUpdate: "",
  loadingUpdate: false,
  errorUpdate: "",
}

const SelectModal = (state = initialState, action) => {
  switch (action.type) {
    case SELECT_MODAL_LIST:
      state = {
        ...state,
        loadingList: true,
        responseList: "",
        errorList: "",
        responseUpdate: "",
        errorUpdate: "",
      }
      break
    case SELECT_MODAL_LIST_SUCCESS:
      state = {
        ...state,
        loadingList: false,
        responseList: action.payload.data
      }
      break
    case SELECT_MODAL_LIST_ERROR:
      state = {
        ...state,
        loadingList: false,
        errorList: action.payload
      }
      break
    case SELECT_MODAL_SELECTED:
      state = {
        ...state,
        loadingSelected: true,
        responseSelected: "",
        errorSelected: "",
      }
      break
    case SELECT_MODAL_SELECTED_SUCCESS:
      state = {
        ...state,
        loadingSelected: false,
        responseSelected: action.payload.data
      }
      break
    case SELECT_MODAL_SELECTED_ERROR:
      state = {
        ...state,
        loadingSelected: false,
        errorSelected: action.payload
      }
      break
    case SELECT_MODAL_UPDATE:
      state = {
        ...state,
        loadingUpdate: true,
        responseUpdate: "",
        errorUpdate: "",
        responseSelected: "",
      }
      break
    case SELECT_MODAL_UPDATE_SUCCESS:
      state = {
        ...state,
        loadingUpdate: false,
        responseUpdate: action.payload.data
      }
      break
    case SELECT_MODAL_UPDATE_ERROR:
      state = {
        ...state,
        loadingUpdate: false,
        errorUpdate: action.payload
      }
      break
    default:
      state = {...state}
      break
  }
  return state
}

export default SelectModal
